// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.projects-news {
  background-color: rgba(var(--white));
  box-sizing: border-box;
}
.projects-news__header {
  padding: 3rem 6.875rem 0;
}
@media (max-width: 768px) {
  .projects-news__header {
    padding: 1.75rem 1rem 1.25rem;
    height: 2.5rem;
  }
}
.projects-news__content {
  padding: 0 6.875rem 3rem;
}
@media (max-width: 768px) {
  .projects-news__content {
    padding: 0;
  }
}
.projects-news__title {
  font-size: 2rem;
  line-height: 1.3;
  font-weight: 500;
  color: rgba(var(--grey-800));
}
@media (max-width: 768px) {
  .projects-news__title {
    font-size: 1.5rem;
    line-height: 1.3;
    padding: 0 1rem;
    margin-top: 0.75rem;
  }
}
.projects-news__list {
  width: 100%;
  margin: 3rem 0 4.5rem;
}
@media (max-width: 768px) {
  .projects-news__list {
    margin: 1.5rem 0;
    padding: 0 16px;
    box-sizing: border-box;
  }
}
.projects-news__list-items {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-content: space-between;
  width: 100%;
  height: max-content;
  grid-gap: 2.5rem;
  box-sizing: border-box;
}
@media (max-width: 768px) {
  .projects-news__list-items {
    display: flex;
    flex-direction: column;
    grid-gap: 1rem;
  }
}
@media (max-width: 768px) {
  .projects-news__list-items .card {
    display: flex;
    gap: 1rem;
  }
}
@media (max-width: 768px) {
  .projects-news__list-items .card__content-date {
    margin-top: 0;
    font-size: 0.75rem;
    line-height: 1.5;
  }
}
@media (max-width: 768px) {
  .projects-news__list-items .card__content-title {
    height: auto;
    -webkit-line-clamp: 4;
  }
}
.projects-news__list-items .card__img {
  height: calc((100vw - 13.75rem - 5rem - 6rem) / 3 / 1.4) !important;
}
@media (max-width: 768px) {
  .projects-news__list-items .card__img {
    height: calc((100vw - 32px - 24px) / 2) !important;
    width: calc((100vw - 32px - 24px) / 2) !important;
    flex-shrink: 0;
    border-radius: 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/News/styles.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,sBAAA;AACF;AACE;EACE,wBAAA;AACJ;AACI;EAHF;IAII,6BAAA;IACA,cAAA;EAEJ;AACF;AACE;EACE,wBAAA;AACJ;AACI;EAHF;IAII,UAAA;EAEJ;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;AACJ;AACI;EANF;IAOI,iBAAA;IACA,gBAAA;IACA,eAAA;IACA,mBAAA;EAEJ;AACF;AACE;EACE,WAAA;EACA,qBAAA;AACJ;AACI;EAJF;IAKI,gBAAA;IACA,eAAA;IACA,sBAAA;EAEJ;AACF;AAAI;EACE,aAAA;EACA,qCAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AAEN;AAAM;EATF;IAUI,aAAA;IACA,sBAAA;IACA,cAAA;EAGN;AACF;AAAQ;EADF;IAEI,aAAA;IACA,SAAA;EAGR;AACF;AACQ;EADF;IAEI,aAAA;IACA,kBAAA;IACA,gBAAA;EAER;AACF;AAEQ;EADF;IAEI,YAAA;IACA,qBAAA;EACR;AACF;AAEM;EACE,mEAAA;AAAR;AAEQ;EAHF;IAII,kDAAA;IACA,iDAAA;IACA,cAAA;IACA,qBAAA;EACR;AACF","sourcesContent":[".projects-news {\n  background-color: rgba(var(--white));\n  box-sizing: border-box;\n\n  &__header {\n    padding: 3rem 6.875rem 0;\n\n    @media (max-width: 768px) {\n      padding: 1.75rem 1rem 1.25rem;\n      height: 2.5rem;\n    }\n  }\n\n  &__content {\n    padding: 0 6.875rem 3rem;\n\n    @media (max-width: 768px) {\n      padding: 0;\n    }\n  }\n\n  &__title {\n    font-size: 2rem;\n    line-height: 1.3;\n    font-weight: 500;\n    color: rgba(var(--grey-800));\n\n    @media (max-width: 768px) {\n      font-size: 1.5rem;\n      line-height: 1.3;\n      padding: 0 1rem;\n      margin-top: 0.75rem;\n    }\n  }\n\n  &__list {\n    width: 100%;\n    margin: 3rem 0 4.5rem;\n\n    @media (max-width: 768px) {\n      margin: 1.5rem 0;\n      padding: 0 16px;\n      box-sizing: border-box;\n    }\n\n    &-items {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n      justify-content: space-between;\n      width: 100%;\n      height: max-content;\n      grid-gap: 2.5rem;\n      box-sizing: border-box;\n\n      @media (max-width: 768px) {\n        display: flex;\n        flex-direction: column;\n        grid-gap: 1rem;\n      }\n\n      .card {\n        @media (max-width: 768px) {\n          display: flex;\n          gap: 1rem;\n        }\n      }\n\n      .card__content-date {\n        @media (max-width: 768px) {\n          margin-top: 0;\n          font-size: 0.75rem;\n          line-height: 1.5;\n        }\n      }\n\n      .card__content-title {\n        @media (max-width: 768px) {\n          height: auto;\n          -webkit-line-clamp: 4;\n        }\n      }\n\n      .card__img {\n        height: calc((100vw - 13.75rem - 5rem - 6rem) / 3 / 1.4) !important;\n\n        @media (max-width: 768px) {\n          height: calc((100vw - 32px - 24px) / 2) !important;\n          width: calc((100vw - 32px - 24px) / 2) !important;\n          flex-shrink: 0;\n          border-radius: 0.5rem;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
